import { BrowserRouter } from 'react-router-dom';
import Screens from './screens';
import React, { useState, useContext, useEffect, useRef } from "react";
import { AuthProvider, AuthContext } from '../src/context/AuthContext';
import Amplify from 'aws-amplify'
import { alertTitleClasses } from '@mui/material';
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { postRefreshToken } from "../src/api/refreshToken";
import 'react-image-crop/dist/ReactCrop.css';
import {useWebSocket} from '../src/hooks/useWebSocket'

Amplify.configure({
  Auth: {
    identityPoolId: "us-east-1:d28531c2-56c0-4fff-a0a9-b776366789fe",
    region: "us-east-1",
  },
  geo: {
    AmazonLocationService: {
      maps: {
        items: {
          "fiado-map": {
            style: "Default style",
          },
        },
        location:
        {

        },
        default: "fiado-map",
      },
      region: "us-east-1",
    },
  },
});


function App() {

  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <RefreshToken>
            <WebSocket>
              <Screens></Screens>
            </WebSocket>
          </RefreshToken>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}


const WebSocket = ({children})=>{
  const {webSocketConnection} = useWebSocket()

  useEffect(()=>{
    webSocketConnection() 
  },[])

  return (
    <>
      {children}
    </>
  );

}

const RefreshToken = ({ children }) => {
  // const [alertActive, setAlertActive] = useState(false);

  const { tokenn, setTokenn, documentProcess,resetContext } = useContext(AuthContext);
  const route = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    setTokenn(token)
  }, []);

  useEffect(() => {
    if (!!tokenn) {
      let tokenDecoded = jwt_decode(tokenn);
      let countDownDate = tokenDecoded?.exp;
      let seconds = Math.round(countDownDate - new Date() / 1000)
      if (seconds <= 10) {
        clearInterval(idTimerExpirationTime.current)
        Swal.fire({
          showCloseButton: true,
          icon: 'error',
          title: 'Lo sentimos',
          text: 'La sesión ha expirado',
        }).then(resp => {
          if (resp.isConfirmed) {
            localStorage.removeItem("token");
            setTokenn(null);
            window.location.reload()
          } else {
            localStorage.removeItem("token");
            setTokenn(null);
            window.location.reload()
          }
        });
      } else {
        clearInterval(idTimerExpirationTime.current);
        expirationTime = seconds;
        idTimerExpirationTime.current = setInterval(() => {
          timerExpirationTime();
        }, 1000);
      }
    } else {
      clearInterval(idTimerExpirationTime.current)
    }
  }, [tokenn]);


  let expirationTime = 0;
  let idTimerExpirationTime = useRef(0);
  let alertActive = false;
  function timerExpirationTime() {
    const _token = localStorage.getItem('token');

    if(!_token){
      clearInterval(idTimerExpirationTime.current)
      setTokenn(null);
      window.location.reload()
    } else {
      let tokenDecoded = jwt_decode(_token);
      let countDownDate = tokenDecoded?.exp;
      expirationTime = Math.round(countDownDate - new Date() / 1000)
      
  
      if (expirationTime <= 10) {



        localStorage.removeItem("token");
        clearInterval(idTimerExpirationTime.current)
        Swal.fire({
          showCloseButton: true,
          icon: 'error',
          title: 'Lo sentimos',
          text: 'La sesión ha expirado',
          confirmButtonColor: "#28a745",
        }).then(resp => {
          if (resp.isConfirmed) {
            resetContext()
            localStorage.removeItem("token");
            setTokenn(null);
            window.location.reload()
          } else {
            resetContext()
            localStorage.removeItem("token");
            setTokenn(null);
            window.location.reload()
          }
        });
      };
  
      const minutes = Math.floor(expirationTime / 60);
      let seconds = expirationTime % 60;
  
      // console.log(`${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
      //   }${seconds}`)
      expirationTime = expirationTime - 1;
    }
  }

  // const RefreshToken = async () => {
  //   try {
  //     const { data } = await postRefreshToken();
  //     localStorage.setItem("token", data.data.accessToken);
  //     setTokenn(data.data.accessToken)
  //     localStorage.setItem("refreshToken", data.data.refreshToken);
  //     return true
  //   } catch (error) {
  //     return false;
  //   }
  // };




  useEffect(() => {
    if (documentProcess) {
      let seconds = 120;
      clearInterval(idTimerExpirationTimeKYC.current);
      expirationTimeKYC = seconds;
      idTimerExpirationTimeKYC.current = setInterval(() => {
        timerExpirationTimeKYC();
      }, 1000);
    }
  }, [documentProcess]);


  let expirationTimeKYC = 0;
  let idTimerExpirationTimeKYC = useRef(0);
  let alertActiveKYC = false;
  function timerExpirationTimeKYC() {
    if (expirationTimeKYC == 0) {
      localStorage.setItem("documentProcess", false);
      clearInterval(idTimerExpirationTimeKYC.current);
    }
    //console.log("expirationTimeKYC", expirationTimeKYC);
    expirationTimeKYC = expirationTimeKYC - 1;
  }


  return (
    <>
      {children}
    </>
  );
};


export default App;
